import { BigNumber } from "ethers";

export const DECIMAL_BASE = BigNumber.from("10");
export const NUMBER_REGEX = /^\d*(\.\d*)?$/;
